<header class="header">
    <a class="header__logo" routerLink="/" *cmLet="(logoConfig$ | async) as logoConfig">
        <img
            class="logo-image"
            [ngClass]="{ 'is-circle': logoConfig.logoFormType === CROPPER_MODES.CIRCLE }"
            [src]="logoConfig.imageConfig.imageFile"
        />
    </a>
</header>
